export default "__VITE_ASSET__C3dXk17r__$_?format=webp__"